export const API_PATH_ApiDeviceMgmtLocationGet = '/services/devices-mgtm/apiDeviceMgmtLocationGet';
